import React, {useState, useRef} from 'react';
import {Translation} from 'react-i18next';
import {Form, Input, Popover, Tooltip, Typography, Space} from 'antd';
import {CheckCircleFilled, CloseCircleOutlined, QuestionCircleOutlined} from '@ant-design/icons';


const incompleteTextType = 'default';
const incompleteIcon = <CloseCircleOutlined style={{ color: '#00000040' }} />;

const completeTextType = 'secondary';
const completeIcon = <CheckCircleFilled style={{ color: '#52c41a' }} />;

const InviteCodeInput = ({name, form, hasError=false, label=null, rules=null, disabled=false, autoFocus=false, useTooltip=true, tooltipPlacement='right', useSuccess=true, ...props}) => {

  const [isVisible, setIsVisible] = useState(false);

  const [isLengthComplete, setIsLengthComplete] = useState(form.getFieldValue(name) && form.getFieldValue(name).length >= 5 && form.getFieldValue(name).length <= 20);

  const inputRef = useRef(null);

  const onChange = e => {
    const val = e.target.value;
    
    // check length
    setIsLengthComplete(val.length >= 5 && val.length <= 20);
  }

  return (
    <Translation>{(t) =>
      <div className="form-group">
        <Popover
          placement={tooltipPlacement}
          trigger="focus"
          title={null}
          visible={useTooltip && isVisible && !isLengthComplete}
          content={
            <>
              <Space direction="vertical">

                <Typography.Text
                  type={isLengthComplete ? completeTextType : incompleteTextType}
                >
                  {isLengthComplete ? completeIcon : incompleteIcon}{' '}
                  {t('input_requirment_length', {min: 5, max: 20})}
                </Typography.Text>

              </Space>
            </>
          }
        >
          <Form.Item
            name={name}
            label={label
              ? label 
              : <span>
                  {t('register_input_invite_code')}&nbsp;
                  <Tooltip title={t('register_form1_tooltip_invite_code')}>
                    <QuestionCircleOutlined />
                  </Tooltip>
                </span>
            }
            rules={rules
              ? rules
              : [
                  {required: true, message: t('feedback_validation_required')},
                  {min: 5, max: 20, message: t('feedback_validation_length', {min: 5, max: 20})},
                ]}
            // hasFeedback={useSuccess && isLengthComplete && !hasError}
            hasFeedback={true}
            validateStatus={hasError ? "error" : (useSuccess && isLengthComplete ? "success" : null)}
          >
            <Input
              disabled={disabled}
              autoFocus={autoFocus}
              onChange={onChange}
              ref={inputRef}
              onFocus={() => setIsVisible(true)}
              onBlur={() => setIsVisible(false)}
            />
          </Form.Item>
        </Popover>
      </div>
    }</Translation>
  )
}

export default InviteCodeInput;
